export var getControlledInputValue = function getControlledInputValue(controlledValue, initialValue, value) {
  if (typeof controlledValue === 'undefined') return value;
  if (controlledValue === null) return initialValue;
  return controlledValue;
};